import { render, staticRenderFns } from "./metadata.vue?vue&type=template&id=368253c2&scoped=true&"
import script from "./metadata.vue?vue&type=script&lang=ts&"
export * from "./metadata.vue?vue&type=script&lang=ts&"
import style0 from "./metadata.vue?vue&type=style&index=0&id=368253c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368253c2",
  null
  
)

export default component.exports